<clr-main-container>
    <app-header title="New Truck"></app-header>

    <div class="content-container">
        <div class="content-area">

            <h2>Create Truck</h2>

            <form clrForm>
                <clr-input-container>
                    <label>Name</label>
                    <input clrInput type="text" [(ngModel)]="item['name']" name="Example Truck Name" />
                </clr-input-container>
                <clr-input-container>
                    <label>VIN</label>
                    <input clrInput type="text" [(ngModel)]="item['vin']" name="Please Input VIN#" />
                </clr-input-container>
                <button class="btn btn-primary" type="submit" [disabled]="!item['name']" (click)="submit()">
                    Submit
                </button>
            </form>


        </div>
    </div>
</clr-main-container>